export default __webpack_public_path__ + "fonts/sketch_transparent.89a1748411a615f651804a25efd2eb48.png";